import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { InputsModule, InputUtilitiesModule, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';

import { PASSWORD_MIN_LENGTH } from '../../../../validators/password-strength.validator';
import { BaryComponentHelper } from '../../util/bary-component-helper';
import { IBaryInput } from '../../../../models/bary-input';
import { MarkAsteriskDirective } from '../../../../directives/mark-asterisk.directive';
import { TranslateDirective } from '../../../../directives/translate.directive';

@Component({
  selector: 'jhi-bary-input-password',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, InputUtilitiesModule, InputsModule, MDBBootstrapModulesPro, MarkAsteriskDirective, TranslateDirective],
  templateUrl: './bary-input-password.component.html',
  styleUrls: ['./bary-input-password.component.scss'],
})
export class BaryInputPasswordComponent implements IBaryInput {
  @Input() id: string = BaryComponentHelper.makeId();
  @Input() label?: string;
  @Input() icon?: string;
  @Input() name?: string;
  @Input() counter: boolean = false;
  @Input() disabled: boolean = false;
  @Input() isConfirm: boolean = false;
  @Input() minLength: number = PASSWORD_MIN_LENGTH;

  @Input() control = new FormControl('');
}
